import { lng } from '@ads/front-core/locales'

interface Advantage {
  name: string
  meta: boolean
  google: boolean
  wpAds: boolean | string
}

export const advantages: Advantage[] = [
  { name: lng('landing:payPerClick'), meta: true, google: true, wpAds: true },
  { name: lng('landing:payPerSell'), meta: false, google: true, wpAds: true },
  {
    name: lng('landing:mailingAdvertisements'),
    meta: false,
    google: false,
    wpAds: true,
  },
  {
    name: lng('landing:productAdvertisements'),
    meta: true,
    google: true,
    wpAds: true,
  },
  {
    name: lng('landing:taxesPaidInPoland'),
    meta: false,
    google: false,
    wpAds: true,
  },
  {
    name: lng('landing:co2free'),
    meta: false,
    google: true,
    wpAds: true,
  },
  {
    name: lng('common:videoAdvertisement'),
    meta: true,
    google: true,
    wpAds: lng('landing:soon'),
  },
]
